import errors from './errors.json'
import {registerErrors} from '../logger/logger'

registerErrors('utils', errors)

export default errors
